import { SystemService } from "./SystemService";
import AuthService from "./AuthService";

class IncomingDeliveriesService {
    systemService = null;
    api = null;
    authService = null;

    constructor() {
        this.systemService = new SystemService();
        this.authService = new AuthService();
        this.api = this.systemService.getApiAccess();
    }

    getProductTransfers(date) {
        let sessionid = this.authService.getSessionId();
        let url = 'incoming-deliveries/erp/product-transfers';
        if (date) {
            url += `?date=${date}`;
        }
        return this.api.get(url, { headers: { authorization: sessionid } }).then(r => r.data);
    }

    getCementPurchases(date) {
        let sessionid = this.authService.getSessionId();
        let url = 'incoming-deliveries/erp/cement-purchases';
        if (date) {
            url += `?date=${date}`;
        }
        return this.api.get(url, { headers: { authorization: sessionid } }).then(r => r.data);
    }

    getIncomingDeliveries(page = 1, limit = 10, search = '', type = '', pending = false) {
        let sessionid = this.authService.getSessionId();
        let url = `incoming-deliveries?page=${page}&limit=${limit}&search=${search}`;
        if (type) url += `&type=${type}`;
        if (pending) url += `&pending=true`;
        return this.api.get(url, { headers: { authorization: sessionid } }).then(r => r.data);
    }

    updateIncomingDelivery(id, delivery) {
        let sessionid = this.authService.getSessionId();
        return this.api.put(`incoming-deliveries/${id}`, delivery, { headers: { authorization: sessionid } }).then(r => r.data);
    }

    createIncomingDelivery(delivery) {
        let sessionid = this.authService.getSessionId();
        return this.api.post('incoming-deliveries', delivery, { headers: { authorization: sessionid } }).then(r => r.data);
    }

    getCompanyVehicles() {
        let sessionid = this.authService.getSessionId();
        return this.api.get('vehicles/all', { headers: { authorization: sessionid } }).then(r => r.data);
    }
}

export default IncomingDeliveriesService;
